const FaqData = {
  sellCar: [
    {
      title: "How can I sell my car quickly in Kolkata?",
      description: "You can sell your car within 24–48 hours with OtoBix. Just submit your car details, schedule a free inspection, and receive the best price with instant payment."
    },
    {
      title: "How do I start selling my car on OtoBix?",
      description: "Start by filling a simple form with your car details. It takes less than 2 minutes, and our team will contact you to proceed with inspection and pricing."
    },
    {
      title: "Is there any cost to sell my car?",
      description: "No, selling your car on OtoBix is completely free. There are no inspection charges, listing fees, or hidden costs."
    },
    {
      title: "How do I get the best price for my car?",
      description: "OtoBix connects you with multiple buyers to get the best market price. Your car is evaluated based on condition, demand, and inspection report."
    },
    {
      title: "Will I receive only one offer or multiple offers?",
      description: "You receive competitive offers based on real market demand. This ensures better pricing compared to dealing with a single buyer."
    },
    {
      title: "Can I reject the offer if I’m not satisfied?",
      description: "Yes, you are free to reject any offer. There is no obligation to sell if the price doesn’t meet your expectations."
    },
    {
      title: "Is car inspection really free?",
      description: "Yes, the inspection is 100% free with no obligations. It helps determine the accurate value of your car."
    },
    {
      title: "Do I need to visit any office for inspection?",
      description: "No, inspection is done at your doorstep. You can choose a time and location that is convenient for you."
    },
    {
      title: "How long does the entire process take?",
      description: "Most cars are sold within 1–2 days. The timeline may vary slightly depending on your car and market demand."
    },
    {
      title: "What documents are required to sell my car?",
      description: "You need RC, insurance, and basic KYC documents. Our team will guide you if anything additional is required."
    },
    {
      title: "Will OtoBix handle ownership transfer?",
      description: "Yes, we handle complete RC transfer and paperwork. You don’t need to visit the RTO or manage documentation yourself."
    },
    {
      title: "Can I sell a car that is under loan?",
      description: "Yes, cars with active loans can also be sold. We assist in closing the loan and completing the process smoothly."
    },
    {
      title: "When will I get paid after selling my car?",
      description: "Payment is processed instantly or within a few hours. Once the deal is confirmed, you receive the full amount securely."
    },
    {
      title: "Is it safe to sell my car online?",
      description: "Yes, OtoBix ensures a safe and verified selling process. All buyers are screened, and transactions are secure to prevent fraud."
    },
    {
      title: "Are there any hidden charges or deductions?",
      description: "No, there are zero hidden charges. The amount you agree on is exactly what you receive."
    },
    {
      title: "Can I sell a car without insurance?",
      description: "Yes, you can still sell your car without valid insurance. However, it may slightly affect the final price."
    },
    {
      title: "Can I sell a damaged or non-running car?",
      description: "Yes, OtoBix accepts cars in all conditions. The price will depend on the car’s condition and inspection."
    },
    {
      title: "What if my RC is lost or not updated?",
      description: "We help you resolve RC-related issues during the process. Our team ensures a smooth transaction even in such cases."
    },
    {
      title: "Why should I choose OtoBix over dealers?",
      description: "OtoBix is faster, safer, and hassle-free. You avoid dealing with multiple buyers, repeated negotiations, and fraud risks."
    },
    {
      title: "How is OtoBix different from local car dealers?",
      description: "OtoBix offers better price discovery and convenience. Instead of one dealer, you get access to a network of buyers competing for your car."
    },
    {
      title: "Am I required to sell my car after inspection?",
      description: "No, there is no obligation to sell. You can decide based on the offer you receive."
    },
    {
      title: "Can I cancel the process anytime?",
      description: "Yes, you can cancel before finalizing the deal. There are no cancellation charges."
    },
    {
      title: "How do I book a free inspection?",
      description: "Simply submit your car details and choose a time slot. Our team will handle the rest and guide you through the process."
    }
  ],
  buyCar: [
    {
      title: "How can I buy a used car online in Kolkata?",
      description: "You can buy a used car in Kolkata easily through OtoBix by browsing available cars and booking your preferred one. Each car is inspected, verified, and ready for a smooth purchase process."
    },
    {
      title: "How do I find the right car for my needs?",
      description: "You can filter cars based on budget, brand, fuel type, and preferences. OtoBix helps you shortlist the best options quickly without visiting multiple dealers."
    },
    {
      title: "Can I book a car online?",
      description: "Yes, you can book your preferred car online in just a few steps. Our team will assist you with the next steps after booking."
    },
    {
      title: "Are the cars inspected before listing?",
      description: "Yes, every car listed on OtoBix goes through a detailed inspection. This ensures quality, transparency, and reliable performance."
    },
    {
      title: "Will I get a report of the car’s condition?",
      description: "Yes, you receive a detailed inspection report before buying. This helps you make an informed decision without surprises."
    },
    {
      title: "Are accidental or damaged cars listed?",
      description: "OtoBix maintains transparency about car conditions. Any major issues, if present, are clearly mentioned in the listing."
    },
    {
      title: "Are the car prices negotiable?",
      description: "Prices may vary depending on the car and demand. You can discuss options with the OtoBix team before finalizing your purchase."
    },
    {
      title: "How do I know I’m getting a fair price?",
      description: "Prices are based on market value, condition, and demand. OtoBix ensures competitive pricing compared to local dealers."
    },
    {
      title: "Are there any hidden charges while buying?",
      description: "No, there are no hidden charges. All costs are clearly communicated upfront."
    },
    {
      title: "Will I get a proper ownership transfer?",
      description: "Yes, OtoBix handles complete ownership transfer. You don’t need to manage RTO paperwork yourself."
    },
    {
      title: "What documents will I receive after purchase?",
      description: "You receive RC, insurance papers, and all required documents. Everything is verified before delivery."
    },
    {
      title: "Can I buy a car that is under loan?",
      description: "Yes, loan clearance is handled before transfer. OtoBix ensures a smooth and legal transaction."
    },
    {
      title: "Is it safe to buy a car online?",
      description: "Yes, OtoBix ensures a secure and transparent buying process. All vehicles and sellers are verified to reduce risk."
    },
    {
      title: "What payment methods are available?",
      description: "You can complete payment through secure and verified methods. Details are shared clearly during the purchase process."
    },
    {
      title: "Do I need to pay the full amount upfront?",
      description: "Payment terms depend on the car and deal structure. The OtoBix team guides you step-by-step to ensure clarity."
    },
    {
      title: "Can I take a test drive before buying?",
      description: "Yes, test drive options are available for selected cars. You can schedule a convenient time through OtoBix."
    },
    {
      title: "How will the car be delivered to me?",
      description: "The car can be delivered to your doorstep or picked up as per your preference. OtoBix ensures a smooth handover process."
    },
    {
      title: "How long does it take to get the car after booking?",
      description: "Delivery timelines depend on documentation and final processing. In most cases, it is completed within a few days."
    },
    {
      title: "Can I exchange my old car while buying a new one?",
      description: "Yes, you can sell your old car and buy a new one through OtoBix. This makes the process faster and more convenient."
    },
    {
      title: "What if I don’t like the car after booking?",
      description: "You can discuss alternatives with the OtoBix team. Customer satisfaction is prioritized throughout the process."
    },
    {
      title: "Why should I buy from OtoBix instead of local dealers?",
      description: "OtoBix offers verified cars, transparent pricing, and hassle-free paperwork. You avoid hidden issues and save time compared to traditional dealers."
    },
    {
      title: "How is OtoBix different from other online platforms?",
      description: "OtoBix focuses on quality, trust, and end-to-end support. From selection to ownership transfer, everything is managed for you."
    },
    {
      title: "How do I book a car today?",
      description: "Simply choose your preferred car and proceed with booking online. Our team will guide you through the next steps quickly."
    }
  ],
  warranty: [
    {
      title: "What is a car warranty?",
      description: "A car warranty is a protection plan that covers repair costs for specific parts of your car. It helps you avoid unexpected expenses due to breakdowns or component failures."
    },
    {
      title: "Why should I buy a car warranty?",
      description: "A car warranty protects you from high repair costs and gives peace of mind. It is especially useful for pre-owned cars where repair risks are higher."
    },
    {
      title: "Is car warranty necessary for used cars?",
      description: "Yes, a warranty is highly recommended for used cars. It helps cover repair expenses and reduces financial risk after purchase."
    },
    {
      title: "What does a car warranty cover?",
      description: "A car warranty typically covers major components like engine, gearbox, and electrical parts. Coverage may vary depending on the plan you choose."
    },
    {
      title: "What is not covered under a car warranty?",
      description: "Regular wear and tear items like tyres, brake pads, and servicing are usually not covered. Always check the plan details for exclusions."
    },
    {
      title: "Can I choose different warranty plans?",
      description: "Yes, you can choose plans based on coverage, duration, and budget. OtoBix helps you select the most suitable option."
    },
    {
      title: "Which cars are eligible for warranty?",
      description: "Most cars are eligible depending on age, condition, and mileage. Newer and well-maintained cars get better coverage options."
    },
    {
      title: "Can I buy a warranty for an old car?",
      description: "Yes, but eligibility depends on the car’s condition and age. Older cars may have limited coverage options."
    },
    {
      title: "How much does a car warranty cost?",
      description: "Warranty cost depends on the car model, age, and coverage plan. It is usually much lower than potential repair expenses."
    },
    {
      title: "Is a car warranty worth it?",
      description: "Yes, a warranty can save you significant repair costs in the long run. It also gives you peace of mind while driving."
    },
    {
      title: "How do I claim the warranty?",
      description: "You can raise a claim when your car faces a covered issue. The process is simple and guided by the support team."
    },
    {
      title: "Where can I get my car repaired under warranty?",
      description: "Repairs are usually done at authorized service centers or partner garages. This ensures quality service and genuine parts."
    },
    {
      title: "How long does claim approval take?",
      description: "Claims are processed quickly depending on the issue and verification. Most claims are handled smoothly without delays."
    },
    {
      title: "How long does a car warranty last?",
      description: "Warranty duration can range from 6 months to 2 years or more. You can choose based on your usage and preference."
    },
    {
      title: "Can I extend my car warranty?",
      description: "Yes, many warranty plans allow extension. This helps you continue protection for a longer period."
    },
    {
      title: "Is it safe to buy a car warranty online?",
      description: "Yes, buying through OtoBix is safe and transparent. All plans are verified and clearly explained before purchase."
    },
    {
      title: "Why should I choose OtoBix for car warranty?",
      description: "OtoBix offers trusted plans, clear coverage, and easy claim support. You get a hassle-free experience from purchase to claim."
    },
    {
      title: "Can I transfer the warranty when I sell my car?",
      description: "Yes, some warranty plans are transferable to the new owner. This can increase your car’s resale value."
    },
    {
      title: "Does warranty increase the resale value of my car?",
      description: "Yes, cars with active warranty are more attractive to buyers. It builds trust and helps you get a better price."
    },
    {
      title: "How do I buy a car warranty?",
      description: "You can purchase a warranty plan online in just a few steps. Choose your plan, submit details, and get instant coverage."
    }
  ],
  inspection: [
    {
      title: "What is a car inspection?",
      description: "A car inspection is a detailed check of your vehicle’s condition, including engine, body, and key components. It helps determine the car’s true value and identifies any issues."
    },
    {
      title: "Why is car inspection important?",
      description: "Car inspection ensures transparency and helps you avoid losses or hidden problems. It is essential for getting the right price while selling or buying a car."
    },
    {
      title: "How can I book a car inspection?",
      description: "You can book a car inspection online in just a few clicks. Choose your preferred time and location, and our team will handle the rest."
    },
    {
      title: "Is the car inspection free?",
      description: "Yes, car inspection is completely free with OtoBix. There are no charges for scheduling or conducting the inspection."
    },
    {
      title: "Do I need to take my car anywhere?",
      description: "No, inspection is done at your doorstep. You can schedule it at your home or office for maximum convenience."
    },
    {
      title: "How long does the inspection take?",
      description: "A typical inspection takes around 30–45 minutes. The duration may vary depending on the car’s condition."
    },
    {
      title: "What does the car inspection include?",
      description: "Inspection covers engine, exterior, interior, tyres, and electrical components. It provides a complete overview of the car’s condition."
    },
    {
      title: "Will I get a detailed inspection report?",
      description: "Yes, you receive a clear and detailed inspection report. This helps you understand your car’s value and condition."
    },
    {
      title: "Is the inspection accurate?",
      description: "Yes, inspections are conducted by trained professionals using standard checks. This ensures reliable and unbiased evaluation."
    },
    {
      title: "How does inspection affect my car price?",
      description: "Inspection helps determine the most accurate market value of your car. Better condition usually leads to a higher price."
    },
    {
      title: "Will the price change after inspection?",
      description: "Yes, the final price may be adjusted based on the inspection report. This ensures fair pricing for both seller and buyer."
    },
    {
      title: "Is car inspection safe?",
      description: "Yes, OtoBix ensures a secure and professional inspection process. Your car remains with you during the inspection."
    },
    {
      title: "Will my personal details be shared?",
      description: "No, your details are kept private and secure. Information is only used for the inspection and selling process."
    },
    {
      title: "Am I required to sell my car after inspection?",
      description: "No, there is no obligation to sell your car. You can decide based on the price offered."
    },
    {
      title: "Can I reschedule or cancel the inspection?",
      description: "Yes, you can reschedule or cancel anytime. There are no cancellation charges."
    },
    {
      title: "Can I get my old or damaged car inspected?",
      description: "Yes, inspection is available for cars in all conditions. Your car will be evaluated accordingly."
    },
    {
      title: "Can I book an inspection for a car I want to buy?",
      description: "Yes, inspection helps buyers verify the car before purchase. It reduces risk and ensures informed decisions."
    },
    {
      title: "How do I schedule a car inspection today?",
      description: "You can book a free inspection online in minutes. Submit your details and choose a convenient time slot."
    }
  ],
  newCarFinance: [
    {
      title: "How can I get a loan for a new car?",
      description: "You can get a new car loan easily through OtoBix with minimal documentation. Just apply online, choose your preferred loan option, and get quick approval from trusted lenders."
    },
    {
      title: "Who can apply for new car finance?",
      description: "Both salaried and self-employed individuals can apply for car finance. Eligibility depends on income, credit profile, and basic documentation."
    },
    {
      title: "How long does loan approval take?",
      description: "Loan approvals are usually completed within 24–48 hours. In some cases, approvals can be even faster depending on your profile."
    },
    {
      title: "What is the eligibility for a car loan?",
      description: "Eligibility depends on your income, age, and credit score. Higher income and a good credit history increase your chances of approval and better loan terms."
    },
    {
      title: "What is the minimum salary required for a car loan?",
      description: "Minimum salary requirements vary by lender. Generally, a stable monthly income is required to qualify."
    },
    {
      title: "Can I get a loan with a low credit score?",
      description: "Yes, but approval and interest rates may vary. OtoBix helps connect you with lenders who offer flexible options."
    },
    {
      title: "How much loan can I get for a new car?",
      description: "You can get up to 80–100% of the car’s on-road price as a loan. The exact amount depends on your eligibility and lender policies."
    },
    {
      title: "What will be my EMI for a car loan?",
      description: "Your EMI depends on loan amount, interest rate, and tenure. Longer tenure reduces EMI but increases total interest paid."
    },
    {
      title: "What is the ideal loan tenure?",
      description: "Loan tenure typically ranges from 1 to 7 years. Choose a tenure that balances affordable EMI and total interest cost."
    },
    {
      title: "What is the interest rate on new car loans?",
      description: "Interest rates vary based on your profile and lender. OtoBix helps you find competitive rates from multiple lenders."
    },
    {
      title: "Are there any hidden charges in car loans?",
      description: "No, all charges are clearly disclosed upfront. This may include processing fees, documentation charges, or foreclosure fees."
    },
    {
      title: "Can I prepay or close my loan early?",
      description: "Yes, most lenders allow prepayment or foreclosure. Some charges may apply depending on the lender."
    },
    {
      title: "What documents are required for car finance?",
      description: "You need basic KYC, income proof, and bank statements. Exact requirements may vary based on your employment type."
    },
    {
      title: "Is documentation complicated?",
      description: "No, the process is simple and guided. OtoBix assists you at every step to ensure smooth approval."
    },
    {
      title: "How long does it take to get the loan amount?",
      description: "Loan disbursement is usually done quickly after approval. In many cases, it happens within a few days."
    },
    {
      title: "Will the loan amount be given to me directly?",
      description: "The loan amount is usually paid directly to the car dealer. This ensures a secure and smooth transaction."
    },
    {
      title: "Can I choose between multiple lenders?",
      description: "Yes, OtoBix connects you with multiple financing partners. You can compare options and select the best one."
    },
    {
      title: "Can I customize my EMI?",
      description: "Yes, EMI can be adjusted based on tenure and loan amount. This helps you manage your monthly budget comfortably."
    },
    {
      title: "Is it safe to apply for a car loan online?",
      description: "Yes, applying through OtoBix is safe and secure. Your data is protected and shared only with verified lenders."
    },
    {
      title: "Why should I choose OtoBix for car finance?",
      description: "OtoBix offers fast approvals, competitive rates, and end-to-end support. You get a simple, transparent, and hassle-free loan experience."
    },
    {
      title: "How do I apply for new car finance?",
      description: "You can apply online in just a few minutes. Submit your details, compare loan options, and proceed with approval."
    }
  ],
  preOwnedCarFinance: [
    {
      title: "How can I get a loan for a used car?",
      description: "You can get a pre-owned car loan easily through OtoBix with a simple online application. Submit your details, choose from multiple lenders, and get quick approval with minimal documentation."
    },
    {
      title: "Can I finance any used car?",
      description: "Yes, most pre-owned cars are eligible for financing. Eligibility depends on the car’s age, condition, and lender policies."
    },
    {
      title: "How long does approval take for a used car loan?",
      description: "Loan approval is usually completed within 24–48 hours. Faster approvals may be possible depending on your profile."
    },
    {
      title: "What is the eligibility for pre-owned car finance?",
      description: "Eligibility depends on your income, credit score, and employment type. A stable income and good credit profile improve your chances."
    },
    {
      title: "What is the maximum loan amount for a used car?",
      description: "You can get up to 70–90% of the car’s value as a loan. The exact amount depends on the car and your eligibility."
    },
    {
      title: "What is the maximum tenure for used car loans?",
      description: "Loan tenure typically ranges from 1 to 5 years. Shorter tenure means higher EMI but lower total interest."
    },
    {
      title: "Are interest rates higher for used car loans?",
      description: "Yes, used car loans usually have slightly higher interest rates than new car loans. This is due to the higher risk associated with pre-owned vehicles."
    },
    {
      title: "How is the interest rate decided?",
      description: "Interest rates depend on your credit score, income, and car details. Better profiles get lower interest rates."
    },
    {
      title: "Are there any hidden charges?",
      description: "No, all charges are disclosed upfront. This may include processing fees or documentation charges."
    },
    {
      title: "How is EMI calculated for a used car loan?",
      description: "EMI depends on loan amount, interest rate, and tenure. You can choose a plan that fits your monthly budget."
    },
    {
      title: "Can I reduce my EMI?",
      description: "Yes, you can reduce EMI by increasing tenure or making a higher down payment. This helps manage your finances better."
    },
    {
      title: "What documents are required for used car finance?",
      description: "You need KYC documents, income proof, and bank statements. Requirements may vary slightly for salaried and self-employed individuals."
    },
    {
      title: "Is the documentation process complicated?",
      description: "No, the process is simple and guided. OtoBix helps you at every step to ensure smooth approval."
    },
    {
      title: "How long does it take to get the loan amount?",
      description: "Loan disbursement happens quickly after approval. In most cases, it is completed within a few days."
    },
    {
      title: "Who receives the loan amount?",
      description: "The loan amount is usually paid directly to the seller or dealer. This ensures a safe and transparent transaction."
    },
    {
      title: "Can I compare loan options from multiple lenders?",
      description: "Yes, OtoBix connects you with multiple financing partners. You can compare interest rates and choose the best option."
    },
    {
      title: "Can I prepay or close the loan early?",
      description: "Yes, most lenders allow prepayment or foreclosure. Charges may apply depending on the lender."
    },
    {
      title: "Is it safe to finance a used car online?",
      description: "Yes, OtoBix ensures a secure and transparent loan process. Your data is protected and shared only with verified lenders."
    },
    {
      title: "Why choose OtoBix for used car finance?",
      description: "OtoBix offers fast approvals, flexible options, and complete support. From loan selection to disbursement, everything is handled smoothly."
    },
    {
      title: "Can I get a loan for an old car?",
      description: "Yes, but eligibility depends on the car’s age. Older cars may have lower loan eligibility or shorter tenure."
    },
    {
      title: "Can I get a loan with a low credit score?",
      description: "Yes, but interest rates may be higher. OtoBix helps you find lenders with flexible criteria."
    },
    {
      title: "How do I apply for pre-owned car finance?",
      description: "You can apply online in just a few minutes. Submit your details, compare loan options, and proceed with approval."
    }
  ],
  loanAgainst: [
    {
      title: "What is a loan against a car?",
      description: "A loan against a car lets you get funds by using your car as collateral without selling it. You can continue using your car while repaying the loan in EMIs."
    },
    {
      title: "How can I get a loan against my car?",
      description: "You can apply online through OtoBix with minimal documentation. Submit your details, get your car evaluated, and receive loan offers from lenders."
    },
    {
      title: "How quickly can I get a loan against my car?",
      description: "Loan approval and disbursement can happen within 24–48 hours. In some cases, funds are released even faster depending on your profile."
    },
    {
      title: "Who is eligible for a loan against a car?",
      description: "Both salaried and self-employed individuals can apply. Eligibility depends on your income, credit profile, and car condition."
    },
    {
      title: "How much loan can I get against my car?",
      description: "You can get up to 70–90% of your car’s current market value. The exact amount depends on the car’s age, condition, and lender policies."
    },
    {
      title: "Can I get a loan on an old car?",
      description: "Yes, but eligibility depends on the car’s age and condition. Older cars may qualify for lower loan amounts or shorter tenure."
    },
    {
      title: "What is the interest rate for a loan against a car?",
      description: "Interest rates vary based on your profile and lender. OtoBix helps you get competitive rates from multiple lenders."
    },
    {
      title: "Are there any hidden charges?",
      description: "No, all charges are clearly communicated upfront. This may include processing fees or documentation charges."
    },
    {
      title: "Can I prepay or close the loan early?",
      description: "Yes, most lenders allow prepayment or foreclosure. Charges may apply depending on the lender."
    },
    {
      title: "Can I still use my car after taking the loan?",
      description: "Yes, you can continue using your car normally. The lender keeps the car as collateral on paper, not physically."
    },
    {
      title: "Will my car be taken by the lender?",
      description: "No, your car is not taken unless you default on the loan. As long as you pay EMIs on time, your car remains with you."
    },
    {
      title: "Is it safe to take a loan against my car?",
      description: "Yes, it is a secure and widely used financing option. OtoBix ensures trusted lenders and transparent processes."
    },
    {
      title: "What documents are required for a loan against a car?",
      description: "You need RC, insurance, KYC, and income proof. Additional documents may be required based on your profile."
    },
    {
      title: "Is the documentation process complicated?",
      description: "No, the process is simple and guided. OtoBix assists you at every step for quick approval."
    },
    {
      title: "How long does it take to get the loan amount?",
      description: "Funds are usually disbursed within a few days after approval. In many cases, it is faster depending on verification."
    },
    {
      title: "How will I receive the loan amount?",
      description: "The loan amount is transferred directly to your bank account. This ensures a smooth and secure process."
    },
    {
      title: "What is the repayment tenure?",
      description: "Loan tenure typically ranges from 1 to 5 years. You can choose a tenure based on your EMI affordability."
    },
    {
      title: "Can I reduce my EMI?",
      description: "Yes, EMI can be reduced by choosing a longer tenure. You can also adjust the loan amount based on your needs."
    },
    {
      title: "Can I get a loan if my car is under loan?",
      description: "Yes, but it depends on lender policies. OtoBix can guide you on available options."
    },
    {
      title: "Can I get a loan with a low credit score?",
      description: "Yes, but interest rates may be higher. OtoBix helps you find lenders with flexible approval criteria."
    },
    {
      title: "Why choose OtoBix for a loan against a car?",
      description: "OtoBix offers quick approvals, competitive rates, and full support. You get a simple, transparent, and hassle-free experience."
    },
    {
      title: "Is a loan against a car better than a personal loan?",
      description: "A loan against a car usually has lower interest rates than personal loans. It is a better option if you own a car and need funds."
    },
    {
      title: "How do I apply for a loan against my car?",
      description: "You can apply online in just a few minutes. Submit your details, get your car evaluated, and receive loan offers instantly."
    }
  ]
};

export default FaqData;
